<template>
  <div class="flex space-x-2 items-center text-sm dark:text-gray-500">
    <button
        @click="previousMonth"
        class="hover:bg-gray-100 rounded cursor-pointer"
    >

      <ChevronLeftIcon class="w-4 h-4"/>
    </button>
    <span>
          {{ currentMonthYear }}
        </span>
    <button
        @click="nextMonth"
        class="hover:bg-gray-100 rounded  cursor-pointer"
    >
      <ChevronRightIcon class="w-5 h-4"/>
    </button>
  </div>
</template>
<script setup lang="ts">
import {computed, ref} from "vue";

const emit = defineEmits(["dateChange"])

const props = defineProps({
  date: {
    type: String,
    required: false,
  },
});

const currentDate = ref(new Date())

const currentMonthYear = computed(() => {
  return currentDate.value.toLocaleDateString('en-US', {
    month: 'long',
    year: 'numeric'
  })
})
import {ChevronLeftIcon, ChevronRightIcon} from "@heroicons/vue/24/solid";

const previousMonth = () => {
  currentDate.value = new Date(
      currentDate.value.getFullYear(),
      currentDate.value.getMonth() - 1,
      1
  )
  emit("dateChange", currentDate.value)
}

const nextMonth = () => {
  currentDate.value = new Date(
      currentDate.value.getFullYear(),
      currentDate.value.getMonth() + 1,
      1
  )
  emit("dateChange", currentDate.value)
}
</script>